module.exports = __webpack_public_path__ + "static/media/Scooter.b54b7e63.svg";